import {Component, EventEmitter, Output} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {AdresseDataService} from '../../../services/adresse-data.service';
import {BehaviorSubject, tap} from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {AdresseModels} from '../../../models/adresse-models';
import {PageEvent} from '@angular/material/paginator';
import AddressListElement = AdresseModels.AddressListElement;

@Component({
    selector: 'app-address-search',
    templateUrl: './address-search.component.html',
    styleUrl: './address-search.component.scss'
})
export class AddressSearchComponent {
    @Output() addressSelected: EventEmitter<string> = new EventEmitter();
    searchForm = new UntypedFormGroup({
        searchString: new UntypedFormControl(''),
        activeOnly: new UntypedFormControl(true),
    });
    protected pageOptions = new BehaviorSubject({pageSize: 5, page: 0});
    protected data$: BehaviorSubject<AdresseModels.AddressSearch> = new BehaviorSubject({resultCount: 0, addresses: [] as AddressListElement[], offset: 0, limit: 0});
    protected displayedColumns: string[] = ['adressNo', 'lastName', 'firstName', 'street1', 'zip', 'city', 'phone01', 'phone03', 'email', 'country'];
    protected hasSearched$ = new BehaviorSubject(false);

    constructor(private addressService: AdresseDataService) {
        // search whenever offset or limit changes
        this.pageOptions.pipe(
            takeUntilDestroyed(),
            tap(args => {
                this.search(args.page);
            })
        ).subscribe();
    }

    public async reSearch() {
        await this.search(this.pageOptions.getValue().page);
    }

    protected async search(page = 0) {
        if (this.searchForm.get('searchString')?.value) {
            this.hasSearched$.next(true);
            const p = this.pageOptions.getValue();
            this.addressService.searchAddress(this.searchForm.get('searchString')?.value, !this.searchForm.get('activeOnly')?.value, p.pageSize * p.page, p.pageSize).pipe(
                tap(res => {
                    this.data$.next(res);
                })
            ).subscribe();
        }
    }

    protected async highlight(row: AddressListElement) {
        this.addressSelected.emit(row.adressID);
    }

    protected async enterPressed(ev: KeyboardEvent) {
        if (ev.key == 'Enter') {
            this.search();
        }
    }

    protected async changePaging($event: PageEvent) {
        this.pageOptions.next({page: $event.pageIndex, pageSize: $event.pageSize});
    }

}
